module.exports = "<div class='panel panel-default'>\n\t<div class='panel-heading'>\n\t\t<h3 class='panel-title'>{{framework}}</h3>\n\t</div>\n\t<div class='panel-body'>\n\t\t<EventButton\n\t\t\taction={{actionCreators.increment}}\n\t\t\tframework={{framework}}\n\t\t\tdisplay='+' />\n\t\t<EventButton\n\t\t\taction={{actionCreators.decrement}}\n\t\t\tframework={{framework}}\n\t\t\tdisplay='-' />\n\t</div>\n\t<div class='panel-footer'>\n\t\t{{#each store.getState().toJS().frameworkScores}}\n\t\t\t<CounterLabel\n\t\t\t\tlabel={{name}}\n\t\t\t\tvalue={{score}} />\n\t\t{{/each}}\n\t</div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/ractive/app.html
// module id = 112
// module chunks = 0